import { Avatar, Box } from "@mui/material";
import { FolderOpen, Upload } from "lucide-react";
import { useTheme } from "../../common/contexts/ThemeContext";
import { resolveImageUrl } from "../../common/utils/imageUrl";

const ProjectIconUpload = ({ icon, previewImage, handleImageChange }) => {
  const { colors } = useTheme();

  const getCurrentImageUrl = () => {
    if (previewImage) return previewImage;
    if (icon) {
      return resolveImageUrl(icon);
    }
    return null;
  };

  const currentImage = getCurrentImageUrl();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mt: 3,
        mb: 3,
      }}
    >
      {/* Icon Preview */}
      <Box
        component="label"
        sx={{
          width: 80,
          height: 80,
          borderRadius: 2,
          border: 2,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          transition: "all 0.2s ease",
          backgroundColor: currentImage ? "transparent" : colors.pageSecondary,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {currentImage ? (
          <>
            <Avatar
              src={currentImage}
              alt="Project Icon"
              variant="rounded"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: 1.5,
              }}
            />
            <Box
              className="upload-overlay"
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: colors.pageSecondary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0,
                transition: "opacity 0.2s ease",
                borderRadius: 1.5,
              }}
            >
              <Upload size={24} color="white" />
            </Box>
          </>
        ) : (
          <FolderOpen
            size={32}
            color={colors.textSecondary}
            style={{ opacity: 0.5 }}
          />
        )}
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          hidden
        />
      </Box>

      {/* Instructions */}
      <Box>
        <Box
          component="label"
          sx={{
            fontWeight: 500,
            fontSize: "0.875rem",
          }}
        >
          Upload project icon
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            hidden
          />
        </Box>
        <Box
          sx={{
            fontSize: "0.75rem",
            color: "text.secondary",
            mt: 0.5,
          }}
        >
          Recommended: Square image, at least 256x256px
          <br />
          Supported formats: JPG, PNG, GIF, WebP
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectIconUpload;
